<template>
    <div class="container">
        <div class="searchBox">
            <div class="left">
                <el-form :inline="true">
                    </el-form-item>
                    <el-form-item>
                        <el-input placeholder="手机号" v-model="formObj.fuzzyQuery" clearable></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button icon="el-icon-search" type="primary" @click="fuzzySearchClick">查询</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <div class="right">
                <!-- <el-form :inline="true">
                    <el-form-item>
                        <el-select placeholder="全部身份" v-model="formObj.userType" @change="multiSearchClick">
                            <el-option label="全部身份" value=""></el-option>
                            <el-option :label="list.text" :value="list.value" :key="index" v-for="(list,index) in userTypeOptions"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-select placeholder="全部审核状态" v-model="formObj.authResult" @change="multiSearchClick">
                            <el-option label="全部审核状态" value=""></el-option>
                            <el-option :label="list.text" :value="list.value" :key="index"  v-for="(list,index) in authResultOptions"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form> -->
                <el-button>下载客户列表</el-button>
            </div>
        </div>
        <div class="tableBox">
            <el-table v-loading="isLoading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 0.8)" ref="multipleTable" border stripe :data="tableData"
                tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="55">
                </el-table-column>
                <el-table-column label="序号" width="70">
                    <template slot-scope="scope">{{ total-((searchObj.page-1)*searchObj.num+ scope.$index) }}</template>
                </el-table-column>
                <el-table-column label="用户ID">
                    <template slot-scope="scope">{{ scope.row.userId }}</template>
                </el-table-column>
                <el-table-column label="头像">
                    <template slot-scope="scope">
                    <!-- {{ scope.row.avatar }} -->
                    <img :src="scope.row.avatar" alt="" class="avatarImg">
                    </template>
                </el-table-column>
                <el-table-column label="昵称" >
                    <template slot-scope="scope">{{ scope.row.nickname }}</template>
                </el-table-column>
                <el-table-column label="手机号" >
                    <template slot-scope="scope">{{ scope.row.phone }}</template>
                </el-table-column>
                <el-table-column label="领劵数量" >
                    <template slot-scope="scope">{{ scope.row.ces }}</template>
                </el-table-column>
                <el-table-column label="用券数量" >
                    <template slot-scope="scope">{{ scope.row.ces }}</template>
                </el-table-column>
                <el-table-column label="首次注册/授权时间">
                    <template slot-scope="scope">{{ scope.row.registerTime }}</template>
                </el-table-column>
                <el-table-column label="最近登录时间">
                    <template slot-scope="scope">{{ scope.row.lastLoginTIme }}</template>
                </el-table-column>
                <!-- <el-table-column label="操作" width="190">
                    <template slot-scope="scope">
                        <div style="text-align: left;">
                            <el-button type="primary" size="mini" @click="toDetail(scope.row)" >查看</el-button>
                            <el-button type="primary" size="mini" @click="toDetail(scope.row)" >优惠卷核销</el-button>
                        </div>
                    </template>
                </el-table-column> -->
            </el-table>
        </div>
        <div class="pageBox">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="searchObj.page"
                :page-size.sync="searchObj.num" layout="total, sizes, prev, pager, next, jumper" :total="total"
                background>
            </el-pagination>
        </div>
        <!-- <div class="ceshi">
			ceshi:
			{{searchObj}}
		</div> -->
    </div>
</template>

<script>
    import {
        json,
        wordData
    } from '@/common/common.js'
    import {
        ajaxPost
    } from '@/common/request.js'
    import {
        utils
    } from '@/common/common.js'
    export default {
        name: 'adminIndex',
        data() {
            return {
                lastPage:'',
                newLinkParamObj:{},
                isShowAddOrderModal:false,
                isLoading: false,
                msg: 'Welcome to Your Vue.js App',
                formObj: {
                    fuzzyQuery: '',
                },
                searchObj: {
                    page: 1,
                    num: 10,
                },
                //表格
                tableData: [],
                multipleSelection: [],
                //分页
                total: 0,
                currentAuthList: "12312312312312",
                isShowModal: false,

            }
        },
        computed: {
            functionViewDetail(){
                // return utils.getCurrentFunction().indexOf("viewCustomerDetail")>-1
                return true
            },
            userTypeOptions() {
                return wordData.user_type
            },
            authResultOptions() {
                return wordData.auth_result
            },
            adminId() {
                let oUserInfo=utils.getItem('userInfo')?JSON.parse(utils.getItem('userInfo')) :{}
                console.log(oUserInfo.adminId,'computed里的adminId')
                return oUserInfo.adminId
            },
            currentPageId(){//当前页面id
               let currentPath=this.$route.path
               let result=utils.getCurrentPageId(currentPath)
               return result
            },

        },
        // watch: {
        //   '$route' (to, from) {
        //       console.log("路由变化------")
        //       console.log(to,from)
        //   }
        // },
        components: {
        },
        methods: {
            getParams(){
              this.lastPage=this.$route.query.from
            },
            back() {
                this.$router.back()
            },
            closeModal() {
                console.log('list.vue 的关闭事件')
                this.isShowModal = false
            },
            openAuth(list) {
                this.currentAuthList = list
                this.isShowModal = true
            },

            toAddOrder(type) {
                let _this=this
                let userId = this.newLinkParamObj.user_id
                let companyName = this.newLinkParamObj.company_name
                let user_cellphone = this.newLinkParamObj.user_cellphone
                console.log(userId)
                console.log(companyName)
                this.isShowAddOrderModal=false
                if(type=='cmt'){//来料加工
                    utils.setSearchObjToSession(_this.searchObj)
                    this.$router.push({
                        name: 'orderAddCmt',
                        params: {
                            userId: userId,
                            companyName: companyName,
                            user_cellphone:user_cellphone
                        }
                    })

                }
                if(type=='oem'){//包工包料
                    utils.setSearchObjToSession(_this.searchObj)
                     this.$router.push({
                        name: 'orderAddOem',
                        params: {
                            userId: userId,
                            companyName: companyName,
                            user_cellphone:user_cellphone
                        }
                    })

                }

            },
            openNewLinkModal(list){
                console.log(list)
                this.isShowAddOrderModal=true
                this.newLinkParamObj=list
            },
            toDetail(list) {
                let _this = this
                let userId = list.user_id
                if (!userId) {
                    _this.$message({
                        message: "该条数据有误，没有userId", //接口返回一个页面
                        type: 'error',
                        duration: 1500
                    });
                } else {
                    utils.setSearchObjToSession(_this.searchObj)
                    this.$router.push({
                        name: 'customerDetail',
                        params: {
                            userId: userId,
                            href: 'customer'
                        }
                    })
                }
            },
            fuzzySearchClick() {
                this.searchObj = {
                    phone: this.formObj.fuzzyQuery,
                    num: this.searchObj.num,
                    page: 1,
                }
                this.getTableLists()
            },
            getTableLists() {
                let _this = this
                this.isLoading = true
                ajaxPost('/admin/getUserInfoList', this.searchObj).then(function(res) {
                    _this.tableData = []
                    _this.isLoading = false
                    if (res.data && res.data.userList) {
                        _this.total = parseInt(res.data.totalCount)
                        res.data.userList.forEach(function(item, index) {
                            let buffer = {}
                            buffer.avatar = item.avatar
                            buffer.lastLoginTIme = item.lastLoginTIme
                            buffer.nickname = item.nickname
                            buffer.phone = item.phone
                            buffer.registerTime = item.registerTime
                            buffer.userId = item.userId
                            _this.tableData.push(buffer)

                        })

                    }
                }, function(res) {
                    _this.isLoading = false
                })
            },
            handleSizeChange(size) { //分页：每页n条
                this.searchObj.num = size
                this.searchObj.page = 1
                this.getTableLists()
            },
            handleCurrentChange(page) { //分页：改变第n页
                this.searchObj.page = page
                this.getTableLists()
            },
            handleSelectionChange(val) { //表格多选框
                this.multipleSelection = val;
                console.log(this.multipleSelection)
            }
        },
        created() {
            console.log("执行created")
        	//获取session里存储的搜索条件，并赋值给当前表单
            this.getParams()

            let _this = this
            let sessionSearch=utils.getSearchObjFromSession()
            if(sessionSearch){
                console.log("session里存储了搜索条件")
                _this.searchObj=sessionSearch
                this.formObj.fuzzyQuery=_this.searchObj.phone
                this.formObj.userType=_this.searchObj.userType
                this.formObj.authResult=_this.searchObj.authResult
            }else if(_this.lastPage=='home'){
                _this.searchObj.authResult='p'
                this.formObj.authResult=_this.searchObj.authResult
            }else{
                console.log("session里没有搜索条件，也不是首页直接跳转")
            }
            console.log(_this.searchObj,'mounted里的搜索条件1111')
            this.getTableLists()

        },
        mounted(){
            console.log("执行mounted")
        }
    }
</script>

<style scoped lang="scss">
    * {
        // outline: 1px solid blue;
    }

    .container {}
    .avatarImg{width: 60px;height:60px;}
    .searchBox {
        padding: 0.25rem 0.25rem 0;

        .left {
            float: left;
        }

        .right {
            float: right;
        }
    }

    .searchBox:after {
        content: "";
        display: block;
        clear: both;
    }

    .tableBox {
        padding: 0.25rem;
    }
</style>



// WEBPACK FOOTER //
// src/pages/customer/list.vue